module.exports = __webpack_public_path__ + "img/Products_Desktop_08.0a9be642.jpg";